import { formatNaira, periodLabel } from "../../lib/leaderboard/format";
import { BOARD_LABEL, RewardView } from "../../features/leaderboards/leaderboardsSlice";

/** Winner popup — one reward at a time; dismissing marks it seen on the server. */
export const RewardPopup = ({ reward, onViewBoard, onDismiss, busy }: { reward: RewardView | null; onViewBoard: () => void; onDismiss: () => void; busy?: boolean }) => {
  if (!reward) return null;
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 px-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-amber-100 text-4xl">🏆</div>
        <h2 className="text-2xl font-extrabold text-gray-900">You won {formatNaira(reward.amount)}!</h2>
        <p className="mt-2 text-gray-600">#{reward.rank} on the {BOARD_LABEL[reward.board]} for {periodLabel(reward.periodType, reward.periodKey)}.</p>
        <p className="mt-3 inline-block rounded-full bg-green-50 px-3 py-1 text-xs font-semibold text-green-700">Credited to your Reward balance</p>
        <button disabled={busy} onClick={onViewBoard} className="mt-5 w-full rounded-xl bg-primary py-3 font-bold text-black disabled:opacity-60">View the board</button>
        <button disabled={busy} onClick={onDismiss} className="mt-1 w-full py-3 font-semibold text-gray-500 disabled:opacity-60">Nice!</button>
      </div>
    </div>
  );
};
